if (!customElements.get('cedre-look-shop')) {
  customElements.define(
    'cedre-look-shop',
    class CedreLookShop extends HTMLElement {
      constructor() {
        super();
        this.openButtons = [...this.querySelectorAll('[data-look-shop-open]')];
        this.modal = this.querySelector('[data-look-shop-modal]');
        this.panel = this.querySelector('[data-look-shop-panel]');
        this.pages = [...this.querySelectorAll('[data-look-shop-page]')];
        this.closeButtons = [...this.querySelectorAll('[data-look-shop-close]')];
        this.prevButton = this.querySelector('[data-look-shop-prev]');
        this.nextButton = this.querySelector('[data-look-shop-next]');
        this.currentLabel = this.querySelector('[data-look-shop-current]');
        this.currentIndex = 0;
        this.openedBy = null;

        this.onKeydown = this.handleKeydown.bind(this);
        this.onOpenClick = this.handleOpenClick.bind(this);
        this.onPrevClick = this.showPrevious.bind(this);
        this.onNextClick = this.showNext.bind(this);
        this.onCloseClick = this.closeModal.bind(this);
      }

      connectedCallback() {
        if (this.modal && !this.modal.dataset.portalMounted) {
          document.body.appendChild(this.modal);
          this.modal.dataset.portalMounted = 'true';
        }

        this.openButtons.forEach((button) => button.addEventListener('click', this.onOpenClick));
        this.closeButtons.forEach((button) => button.addEventListener('click', this.onCloseClick));
        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      }

      disconnectedCallback() {
        this.openButtons.forEach((button) => button.removeEventListener('click', this.onOpenClick));
        this.closeButtons.forEach((button) => button.removeEventListener('click', this.onCloseClick));
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
        document.removeEventListener('keydown', this.onKeydown);
        document.body.classList.remove('look-shop-modal-open');
        if (this.modal && this.modal.parentNode === document.body) {
          this.modal.remove();
        }
      }

      handleOpenClick(event) {
        const button = event.currentTarget;
        const index = Number(button.dataset.lookShopOpen);
        if (Number.isNaN(index)) return;
        this.openModal(index, button);
      }

      openModal(index, openedBy) {
        if (!this.modal || !this.panel || this.pages.length === 0) return;
        this.openedBy = openedBy || null;
        this.modal.classList.add('is-open');
        document.body.classList.add('look-shop-modal-open');
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        document.addEventListener('keydown', this.onKeydown);
        this.updateOpenButtons(openedBy);
        this.showPage(index);
        if (typeof trapFocus === 'function') {
          const focusTarget = this.panel.querySelector('[data-look-shop-close]') || this.panel;
          trapFocus(this.panel, focusTarget);
        }
      }

      closeModal() {
        if (!this.modal) return;
        this.modal.classList.remove('is-open');
        document.body.classList.remove('look-shop-modal-open');
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        document.removeEventListener('keydown', this.onKeydown);
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.openedBy);
        } else if (this.openedBy) {
          this.openedBy.focus();
        }
        this.updateOpenButtons(null);
      }

      handleKeydown(event) {
        if (event.code === 'Escape') {
          this.closeModal();
          return;
        }
        if (event.code === 'ArrowLeft') {
          this.showPrevious();
          return;
        }
        if (event.code === 'ArrowRight') {
          this.showNext();
        }
      }

      showPrevious() {
        if (this.pages.length <= 1) return;
        const previousIndex = this.currentIndex <= 0 ? this.pages.length - 1 : this.currentIndex - 1;
        this.showPage(previousIndex);
      }

      showNext() {
        if (this.pages.length <= 1) return;
        const nextIndex = this.currentIndex >= this.pages.length - 1 ? 0 : this.currentIndex + 1;
        this.showPage(nextIndex);
      }

      showPage(index) {
        if (index < 0 || index >= this.pages.length) return;
        this.currentIndex = index;
        this.pages.forEach((page, pageIndex) => {
          const isActive = pageIndex === index;
          page.hidden = !isActive;
          page.classList.toggle('is-active', isActive);
          page.setAttribute('aria-hidden', String(!isActive));
        });
        this.updateNavigation();
        window.requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }

      updateNavigation() {
        if (this.prevButton) this.prevButton.disabled = this.pages.length <= 1;
        if (this.nextButton) this.nextButton.disabled = this.pages.length <= 1;

        if (!this.currentLabel) return;
        const activePage = this.pages[this.currentIndex];
        const label = activePage ? activePage.dataset.lookShopTitle || '' : '';
        this.currentLabel.textContent = label;
      }

      updateOpenButtons(activeButton) {
        this.openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', button === activeButton ? 'true' : 'false');
        });
      }
    }
  );
}
